import React from 'react';
import { H3, P, TCap, Code } from '../../components/tech/TechUI';

const EPISODE = `{
  "episode_id": "20260716_WH_PickPack_VC_09m57s_5Z3G5C",
  "capture_start_iso": "2026-07-16T10:56:08.039Z",
  "capture_stop_iso": "2026-07-16T11:06:06.000Z",
  "fps": 30.0,
  "duration_sec": 597.961,
  "max_timesteps": 17935,
  "rig": {
    "description": "JanData Cap head-worn rig: 6 cameras (left/right eye stereo pair, left/right side, left/right front), 1920x1080 @30fps H.264, 3 IMUs",
    "mounting": {
      "cam_high": "head, left eye",
      "cam_right_eye": "head, right eye",
      "cam_left": "cap, left side",
      "cam_right": "cap, right side",
      "cam_left_front": "cap, left front",
      "cam_right_front": "cap, right front"
    },
    "resolution": [1920, 1080],
    "imu": "3 IMUs"
  },
  "cameras": {
    "cam_high": {"role": "egocentric", "resolution": [1920, 1080], "is_pose_source": true},
    "cam_right_eye": {"role": "egocentric_stereo_pair", "resolution": [1920, 1080], "is_pose_source": false},
    "cam_left": {"role": "head_side", "resolution": [1920, 1080], "is_pose_source": false},
    "cam_right": {"role": "head_side", "resolution": [1920, 1080], "is_pose_source": false},
    "cam_left_front": {"role": "head_front", "resolution": [1920, 1080], "is_pose_source": false},
    "cam_right_front": {"role": "head_front", "resolution": [1920, 1080], "is_pose_source": false}
  },
  "task_id": "PickPack",
  "task_name": "Picker / Packer",
  "language_instruction": "Pick and scan items from storage boxes and bins, pack them into mailer bags, apply shipping labels, and seal the packages.",
  "spans": [
    {"start_time": 0.0, "end_time": 28.5, "label": "talk to coworker"},
    {"start_time": 28.5, "end_time": 31.0, "label": "use computer mouse"},
    {"start_time": 31.0, "end_time": 35.5, "label": "pick item from box"},
    {"start_time": 35.5, "end_time": 46.5, "label": "scan barcode on item"},
    {"start_time": 46.5, "end_time": 52.0, "label": "place item on table"},
    {"start_time": 52.0, "end_time": 55.5, "label": "pick item from box"},
    {"start_time": 55.5, "end_time": 59.0, "label": "scan barcode on item"},
    … 72 more spans
  ],
  "pose_modality": "2d_normalized",
  "pose_modalities_present": ["hand"],
  "coverage": {"hand_left_pct": 58.4, "hand_right_pct": 58.7, "low_coverage_flag": false},
  "episode_tags": ["jandata", "egocentric", "source_format:mp4", "hand_pose", "hand_2d_normalized"],
  "source_provenance": {"site": "Warehouse", "clip_id": "segment1"}
}`;

export const MetadataSection = () => (
  <>
    <H3 id="metadata">Metadata</H3>
    <P>Every recording ships with a metadata record in JSON that describes the rig, the task and the labels.</P>
    <TCap title="Episode metadata.">The record delivered with each recording, taken from a real one: rig and cameras, task, a plain-language instruction, timed action spans and hand-pose coverage. The spans are cut to the first few.</TCap>
    <Code testid="code-episode-metadata">{EPISODE}</Code>
  </>
);
